import { render } from "./Jumbotron.vue?vue&type=template&id=3f4f7073"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__